import type {
  MRT_DefinedColumnDef,
  MRT_RowData
} from "mantine-react-table-open";

/**
 * Returns the row field a column reads its data from: its `accessorKey`, falling back to its `id`.
 * Use this instead of the column id whenever a column id may differ from the data field, e.g. when the same field is shown in several column groups.
 */
export function getColumnDataKey<TData extends MRT_RowData>(
  columnDef: Pick<MRT_DefinedColumnDef<TData>, "accessorKey" | "id">
): string {
  return columnDef.accessorKey ?? columnDef.id;
}
